import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Capa de servicios de la transferencia de pagos de una estudiante a otra
// gestión (pestaña "Transferencia de pagos" de Deuda_est.vue).
// Backend: `UNICEN/modules/economico`. Contrato:
// `UNICEN/modules/economico/docs/transferencias-pago.openapi.yaml`.
//
//   POST /economico/transferencias-pago
//        body: { unicodigo, id_plan_estudio, id_gestion_destino,
//                fecha_resolucion, resolucion, observacion,
//                pagos: [{ id_item_seguimiento, numero_factura, monto }] }
//        -> 201 { mensaje, data: { id_baja_academica, total, pagos, ... } }
//
//        Reemplaza a POST /pagos/addtransferencia/:p1,...,:p12 SOLO para esta
//        pantalla; Recibos, Anular y Cambiopass siguen con el endpoint viejo.
//
//        La sede y el usuario NO se mandan: el backend los saca del token.
//        Los textos viajan tal cual, con `/ , % $`: no hace falta escapar
//        nada. Todos los pagos se registran o no se registra ninguno.
//
//   Errores: `{ mensaje, campo? }`. 400 con `campo` cuando un dato falta o está
//   mal (`pagos[1].monto` señala el segundo pago); 401 sin sesión válida.
//   Usar `mensajeDeError` / `errorDeApi` de `api/errores.js`.

const resource = '/economico/transferencias-pago';

const useTransferenciaPagoApi = {
  registrar(datos) {
    return apiClient.post(resource, datos, conToken());
  },
};

export default useTransferenciaPagoApi;
